// extracted by mini-css-extract-plugin
export default {"bg-primary-dark":"TextArea_bg-primary-dark__WeHBg","bg-primary-light":"TextArea_bg-primary-light__jWnHH","root":"TextArea_root__KRjdl"};